import { Chart, useChart } from '@chakra-ui/charts';
import { Badge, Card, Flex, Stat } from '@chakra-ui/react';
import { memo } from 'react';
import { Area, AreaChart } from 'recharts';

const Sparkline = () => {
  const chart = useChart({
    data: [
      { value: 10 },
      { value: 16 },
      { value: 19 },
      { value: 15 },
      { value: 12 },
      { value: 15 },
      { value: 10 },
      { value: 18 },
    ],
    series: [{ name: 'value', color: 'teal.solid' }],
  });

  return (
    <Chart.Root width="28" height="12" chart={chart}>
      <AreaChart data={chart.data}>
        {chart.series.map((item) => (
          <Area
            key={item.name}
            isAnimationActive={false}
            dataKey={chart.key(item.name)}
            fill={chart.color(item.color) as string}
            fillOpacity={0.2}
            stroke={chart.color(item.color) as string}
            strokeWidth={2}
          />
        ))}
      </AreaChart>
    </Chart.Root>
  );
};

interface Props {
  type: 'weekly' | 'total';
}
const UnitSalesOverview = ({ type }: Props) => {
  return (
    <Card.Root w="full" bg="surface.background" borderColor="border.light">
      <Card.Body>
        <Flex>
          <Stat.Root>
            <Stat.Label>{type === 'weekly' ? 'Weekly Sales' : 'Total Sales'}</Stat.Label>
            <Stat.ValueText>192.1k</Stat.ValueText>
            <Badge colorPalette="green" variant="plain" px="0">
              <Stat.UpIndicator />
              1.9%
            </Badge>
          </Stat.Root>
          <Sparkline />
        </Flex>
      </Card.Body>
    </Card.Root>
  );
};

export default memo(UnitSalesOverview);
